<template>
	<div>
		<p>
			<el-select v-model="query.type" style="width: 150px;margin-right: 20px;" size="small">
				<el-option v-for="item in keys" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-input type="text" style="width: 250px;margin-right: 20px;" size="small" v-model="query.text"
				@keydown.enter.native="filterOrder()">
			</el-input>
			<span style="margin-left: 10px; margin-right: 40px;">门店</span>
			<el-select v-model="query.storeId" @change="filterOrder()" clearable filterable
				style="width: 150px; margin-right: 30px;" size="small">
				<el-option-group label="营业门店" class="store">
					<el-option v-for="item in stores" :key="item.id" :label="item.title" :value="item.id">
					</el-option>
				</el-option-group>
				<el-option-group label="结业门店">
					<el-option v-for="item in storesEnd" :key="item.id" :label="item.title" :value="item.id">
					</el-option>
				</el-option-group>
			</el-select>
			状态
			<el-select v-model="query.orderStatus" collapse-tags @change="filterOrder()"
				style="width: 150px;margin-left: 10px;margin-right: 20px;" size="small">
				<el-option v-for="item in orderStateList" :key="item.value" :label="item.label" :value="item.value"
					:disabled="query.orderStatus[0]==100 && item.value !=100 ">
				</el-option>
			</el-select>
			类型
			<el-select v-model="query.orderType" @change="filterOrder()" style="width: 150px;margin-left: 10px;"
				size="small">
				<el-option v-for="item in orderTypeList" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
		</p>
		<p>
			<span style="margin-left: 5px; margin-right: 10px;">支付方式</span>
			<el-select v-model="query.payType" @change="filterOrder()"
				style="width: 150px;margin-left: 0px;margin-top: 1px;" size="small">
				<el-option v-for="item in payMethodList" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<span style="float: right; ">
				<el-button size="small" class="buttonStyle01" @click="query.page = 1, filterOrder()">筛选
				</el-button>
				<el-button size="small" class="buttonStyle" @click="reload()">重置</el-button>
			</span>
		</p>
		<el-table :data="orders">
			<el-table-column prop="id" label="ID"></el-table-column>
			<el-table-column prop="" label="workerId">
				<template slot-scope="{row}">
					{{row.workerId}}
				</template>
			</el-table-column>
			<el-table-column prop="" label="workerName">
				<template slot-scope="{row}">
					{{row.workerName}}
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload.vue"
	export default {
		components: {
			upload,
		},
		data() {
			return {
				orders: [],
				stores: [], //营业门店
				storesEnd: [], //全部门店
				query: {
					page: 1,
					size: 10,
					total: null,
					type: 1,
					text: "",
					addTime: null,
					orderStatus: [],
					orderType: [],
					channel: "",
					payType: "",
					timeType: '0',
					storeId: undefined,
				},
				keys: [{
					label: "订单号",
					value: 1,
				}, {
					label: "剪发订单ID",
					value: 0,
				}, {
					label: "用户ID",
					value: 3,
				}, {
					label: "商品名称",
					value: 2,
				}, ],
				payMethodList: [{
					label: "全部",
					value: "",
				}, {
					label: "微信支付",
					value: "微信支付",
				}, {
					label: "微信支付-现金",
					value: "微信支付-现金",
				}, {
					label: "美团核销码",
					value: "美团核销码",
				}, {
					label: "哈喽支付",
					value: "哈喽支付",
				}, {
					label: "抖音审核",
					value: "抖音审核",
				}, ],
				orderStateList: [{
					label: "全部",
					value: 100,
				}, {
					label: "排队中",
					value: 0,
				}, {
					label: "服务中",
					value: 1,
				}, {
					label: "待付款",
					value: 2,
				}, {
					label: "已支付",
					value: 3,
				}, {
					label: "已完成",
					value: 5,
				}, {
					label: "已取消",
					value: -1,
				}, {
					label: "支付中",
					value: 21,
				}, ],
				orderTypeList: [{
					label: "全部",
					value: "",
				}, {
					label: "普通订单",
					value: "1",
				}, {
					label: "会员权益订单",
					value: "11",
				}, {
					label: "无限卡订单",
					value: "4",
				}, {
					label: "会员订单",
					value: "6",
				}, {
					label: "会员续费订单",
					value: "7",
				}, {
					label: "次卡订单",
					value: "3",
				}, {
					label: "美团订单",
					value: "9",
				}, {
					label: "企业剪订单",
					value: "2",
				}, {
					label: "染发订单",
					value: "101"
				}, {
					label: "染发次卡订单",
					value: "10",
				}, {
					label: "膨胀券订单",
					value: "5",
				}, ],
			}
		},
		filters: {
			typeFormat(val) {
				switch (val) {
					case "1":
						return "普通订单";
					case "3":
						return "次卡订单";
					case "10":
						return "染发次卡订单";
					case "5":
						return "膨胀券订单";
					case "6":
						return "会员订单";
					case "7":
						return "会员续费订单";
					case "9":
						return "美团订单";
					case "2":
						return "企业剪订单";
					case "11":
						return "权益订单";
					default:
						return "/";
				}
			},
		},
		mounted() {
			this.getStores()
		},
		methods: {
			filterOrder() {
				this.getOrders();
			},
			getOrders() {
				this.loading = true;
				let t = setTimeout(() => { //15秒超时
					this.loading = false
					this.$message.error("请求失败")
				}, 15000)
				this.$http.get("handle/Orders" + this.requestData()).then(res => {
					if (res.data.code == 200) {
						this.orders = res.body.data.rows;
						this.query.total = res.body.data.total;
					} else {
						this.$message.error(res.data.msg);
					}
					this.loading = false
					clearTimeout(t)
					console.log("销毁定时器")
				})
			},
			requestData() {
				let query = "?page=" + this.query.page + "&size=" + this.query.size;
				if (this.query.text) query += "&type=" + this.query.type + "&text=" + this.query.text;
				if (this.query.time) query += "&startTime=" + this.query.time[0] + "&endTime=" + this.query.time[1];
				if (this.query.orderStatus !== 100) query += "&orderStatus=" + this.query.orderStatus.toString();
				if (this.query.orderType) query += "&orderType=" + this.query.orderType;
				if (this.query.channel) query += "&channel=" + this.query.channel;
				if (this.query.payType) query += "&payType=" + this.query.payType;
				if (this.query.storeId) query += "&storeId=" + this.query.storeId;
				if (this.query.timeType) query += "&timeType=" + this.query.timeType;
				return query;
			},
			reload() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					type: 1,
					text: "",
					addTime: null,
					orderStatus: [],
					orderType: "",
					channel: "",
					payType: "",
					timeType: '0'
				};
				this.getOrders();
				this.getSummary();
			},
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType === 1) {
							this.storesEnd.push(ele) //结业门店
						} else {
							this.stores.push(ele) //营业门店
						}
					})
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.buttonStyle01 {
		margin-right: 10px;
		font-family: SourceHanSansCN-Bold;
		color: #FFFFFF;
		background: #4AB52E !important;
		border-radius: 5px;
	}

	.buttonStyle {
		font-family: SourceHanSansCN-Bold;
		background: #FFFFFF !important;
		border-radius: 5px;
		border: 1px solid #CBC9C9;
	}
</style>